import type { ReactNode } from 'react';
import { cn } from '@parrot-software/utils';

import { WizardStepBackButton } from './WizardStepBackButton';

type WizardStepFooterProps = {
  children?: ReactNode;
  className?: string;
};

/**
 * Shared footer bar for wizard steps (Figma node 1155-72194).
 *
 * Left side: the desktop-only icon-only back button ({@link WizardStepBackButton}),
 * fed by the wizard navigation context — when the active step exposes no `onBack`
 * the left side stays empty. Right side: the step's action buttons (`children`),
 * kept right-aligned in both cases so every step can reuse the same footer.
 *
 * @param {WizardStepFooterProps} props - Component properties
 * @param {ReactNode} [props.children] - Step action buttons rendered on the right side
 * @param {string} [props.className] - Extra classes merged into the footer container
 */
export const WizardStepFooter = ({ children, className }: WizardStepFooterProps) => (
  <div className={cn('flex items-center justify-between gap-2 font-sans', className)}>
    <WizardStepBackButton />
    <div className="flex flex-1 items-center justify-end gap-2">{children}</div>
  </div>
);
